import type { QuestionnaireContent, UserAnswer } from "../types";

export const mergeContentWithAnswers = (
  requestId?: string,
  questionnaire?: QuestionnaireContent,
  patientAnswers: UserAnswer[] = [],
) => {
  if (!questionnaire) return undefined;

  const relevantAnswers = requestId
    ? patientAnswers.filter(
        (answer) =>
          answer.surveyId === questionnaire.clinicalId &&
          answer.requestId === requestId,
      )
    : [];

  return {
    ...questionnaire,
    questions: questionnaire.questions.map((question) => {
      const userAnswers = question.optionGroup.options.filter((option) =>
        relevantAnswers.find(
          ({ answerId, questionId }) =>
            answerId === option.optionId && questionId === question.questionId,
        ),
      );
      return { ...question, userAnswers };
    }),
  };
};
